import { useQueryClient } from '@tanstack/react-query';
import * as R from 'ramda';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import { useOrderCalculateContext } from '../../contexts/OrderCalculate.context';
import { SavedStackItem } from '../../interfaces/use-order-item-stack.types';
import { invalidateAffectedOrderProductsGridQueries } from '../../utils/orderCalculate.utils';

interface UseOrderProductsGridSaveParams {
  isOfflineMode?: boolean;
}

const useOrderProductsGridSave = ({ isOfflineMode = false }: UseOrderProductsGridSaveParams) => {
  const queryClient = useQueryClient();
  const { team } = useApplicationContext();
  const { calculateSummary } = useOrderCalculateContext();

  const handleAfterSave = async (savedItems: SavedStackItem[]) => {
    await calculateSummary();

    const byOrder = R.groupBy((item: SavedStackItem) => item.orderId, savedItems);
    R.toPairs(byOrder).forEach(([orderId, items]) => {
      if (!orderId || !items?.length) {
        return;
      }
      invalidateAffectedOrderProductsGridQueries({
        orderId,
        queryClient,
        teamId: team?.id,
        isOfflineMode,
        affectedOrderProducts: items,
      });
    });
  };

  return handleAfterSave;
};

export default useOrderProductsGridSave;
